
/* Binds to region dropdowns when filtering Event / Group pages */
export const regionDropdown = {
    onDocumentLoad
}

const onDocumentLoad = function() {
    var disallowedQueryParameters = ['p', 'city'];
    var dropdown = document.getElementById('regions');

    if (dropdown !== undefined && dropdown !== null) {
        const searchParams = new URLSearchParams(window.location.search);

        disallowedQueryParameters.forEach((e) => {
            searchParams.delete(e);
        });
        
        dropdown.addEventListener("change", function(e) {
            const changedValue = e.target.value;
            var queryName = e.target.getAttribute('name');
            if (changedValue.length > 0) {
                searchParams.set(queryName, changedValue);
            }
            
            window.location.search = searchParams;
        });
    }
}